module.exports = __webpack_public_path__ + "images/logo-santa-casa-porto-alegre.jpg?b97739e3441434ae633075c690d3004c";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/fidelidade/logo-santa-casa-porto-alegre.jpg
// module id = 985
// module chunks = 0